import React, { useMemo } from 'react';
import { Box, Typography, useTheme } from '@mui/material';
import { HorizontalCardSkeleton } from '../../components/DashboardSkeletons';
import InternationalSection from './components/InternationalSection';
import { getInternationalTabStyles } from './InternationalTabCss';
import { useInternationalData, SECTION_NAMES, SECTION_TITLES } from './hooks/useInternationalData';

const InternationalTab = () => {
  const theme = useTheme();
  const isDark = theme.palette.mode === 'dark';
  const styles = useMemo(() => getInternationalTabStyles(theme, isDark), [theme, isDark]);

  const { loading, error, sections } = useInternationalData();

  if (error) {
    return (
      <Box sx={styles.errorBox}>
        <Typography sx={styles.errorText}>
          Unable to load market data. Please try again later.
        </Typography>
      </Box>
    );
  }

  if (loading) {
    return (
      <Box sx={styles.container}>
        {Object.values(SECTION_NAMES).map((name) => (
          <Box key={name}>
            <Typography variant="h6" fontWeight={700} mb={1.5}>
              {SECTION_TITLES[name]}
            </Typography>
            <HorizontalCardSkeleton count={4} />
          </Box>
        ))}
      </Box>
    );
  }

  return (
    <Box sx={styles.container}>
      {Object.values(SECTION_NAMES).map((name) => (
        <InternationalSection
          key={name}
          title={SECTION_TITLES[name]}
          instruments={sections[name]}
        />
      ))}
    </Box>
  );
};

export default React.memo(InternationalTab);
